'use client';

import { createContext, useContext, useMemo } from 'react';
import { useGetTaxonomyRole } from '@/api/generated/taxonomy/taxonomy';
import { useAuthContext } from '@/hooks/use-auth';

const DEFAULT_TAXONOMY_ROLES = ['nebulyadmin'];

const TaxonomySettingsContext = createContext<{ enabled: boolean; isLoading: boolean }>({
  enabled: false,
  isLoading: true,
});

export const TaxonomySettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const { data, isLoading } = useGetTaxonomyRole();
  const { hasRole } = useAuthContext();
  const taxonomyRoles = data?.roles ?? DEFAULT_TAXONOMY_ROLES;
  const enabled = useMemo(() => hasRole(...taxonomyRoles), [hasRole, taxonomyRoles]);

  return <TaxonomySettingsContext.Provider value={{ enabled, isLoading }}>{children}</TaxonomySettingsContext.Provider>;
};

export const useTaxonomySettingsContext = () => useContext(TaxonomySettingsContext);
